<div class="alert alert-info" *ngIf="(comments$ | async)!.length">
  <strong>Comments:</strong>
  <ul>
    <li *ngFor="let comment of comments$ | async">{{ comment }}</li>
  </ul>
</div>
